import { last, split } from 'libraries/lodash'

export const cmp = s => last(split(s || '', '/'))
export const isActive = ({ href, pageId }) => cmp(href) === cmp(pageId)
